<template>
  <div class="album-config">
    <!-- <el-tooltip v-if="process===2" content="复制SPU" placement="bottom-start" class="icon-tips">
      <div slot="content" class="tips-content">
        <p>1. 直接拖拽单个商品可进行排序。</p>
        <p>2. 单击图片可选中对应商品，选中后拖拽可进行排序。</p>
        <p>3. 按住Shift键选择指定范围内的商品实现商品多选，选中后拖拽可进行排序。</p>
        <p>4. 点击“取消选中”按钮可取消选中商品</p>
      </div>
      <div><i class="icon-help iconfont"></i></div>
    </el-tooltip> -->
    <div class="f-a-c bg-white" style="padding:0 60px">
      <div class="step-bar bg-white f-c-c">
        <div>1、基础信息</div>
        <div :style="{ background: (process >1 ? bg2: bg1) }">2、设置商品</div>
        <!-- <div v-if="(form.level!==1 || form.type!==2)" :style="{ background: (process >2 ? bg2: bg1) }">3、商品排序</div> -->
      </div>
      <div v-if="process === 2" class="tips-content">
        <div class="f explain">
          <p>说明：</p><p>1. 直接拖拽单个商品可进行排序。</p>
        </div>
        <p>2. 单击图片可选中对应商品，选中后拖拽可进行排序。</p>
        <p>3. 按住Shift键选择指定范围内的商品实现商品多选，选中后拖拽可进行排序。</p>
        <p>4. 点击“取消选中”按钮可取消选中商品</p>
      </div>
    </div>
    <div v-if="process === 1" class="box bg-white">
      <!-- <h3>基本信息</h3> -->
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="专辑名称:" prop="name">
          <el-input v-model="form.name" style="width: 600px" :disabled="albumType>=1" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="SEO标题:" prop="seoTitle">
          <el-input v-model="form.seoTitle" style="width: 600px" :maxlength="150" placeholder="请输入SEO标题"></el-input>
          {{ form.seoTitle ? form.seoTitle.length : 0 }}/150
        </el-form-item>
        <el-form-item label="SEO描述:" prop="seoDescription">
          <el-input v-model="form.seoDescription" style="width: 600px" :maxlength="300" placeholder="请输入SEO描述"></el-input>
          {{ form.seoDescription ? form.seoDescription.length : 0 }}/300
        </el-form-item>
        <el-form-item label="SEO关键词:">
          <el-input v-model="form.seoKeyWords" style="width: 600px" :maxlength="200" placeholder="请输入SEO关键词"></el-input>
          {{ form.seoKeyWords ? form.seoKeyWords.length : 0 }}/200
        </el-form-item>
        <el-form-item label="网址:" prop="moduleUrl">
          <div class="site-url f--c">
            <div style="flex-shrink: 0;">{{ kakaUrl }}</div>
            <el-input v-model="form.moduleUrl" style="width: 300px" :maxlength="100" placeholder="请输入网址"  @input="handleInput" :disabled="!!id"></el-input>
            <i class="pointer iconfont el-icon-document-copy" @click="handleCopy"></i>
          </div>
        </el-form-item>
        <el-form-item label="页面标题:">
          <el-input v-model="form.pageTitle" style="width: 600px" :disabled="albumType>=1" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="专辑描述:" prop="description">
            <rich-editor :value="form.description" style="width: 1000px"  :disabled="albumType>=1" @input="inputRichEditorValue"/>
        </el-form-item>
        <el-form-item label="首页是否显示:">
          <el-switch v-model="form.showStatus" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="优先级:" prop="sort">
          <el-input placeholder="请输入" v-model="form.sort" :maxlength="3" min="1" style="width: 140px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="首页标题:" prop="mainUrl">
          <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'mainUrl')">
          <div v-if="form.mainUrl" class="img f-c-c">
            <img :src="form.mainUrl" style="width:1000px;height:177px">
          </div>
          <div v-else class="f-c-c fd-c" style="height:100%;width:1000px;">
            <i class="el-icon-plus avatar-uploader-icon" />
            <p>高度固定135像素，（建议宽高比：1062 x 135）</p>
          </div>
        </el-upload>
      </el-form-item>
        <!-- <el-form-item label="专辑链接:">
          <el-button v-if="linkUrl" size="medium" type="text" round @click="open">{{linkUrl}}</el-button>
          <div v-else>自动生成</div>
        </el-form-item> -->
        <el-form-item label="banner图:" prop="bannerImgUrl">
          <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file,'bannerImgUrl')">
            <div v-if="form.bannerImgUrl" class="img f-c-c">
              <img :src="form.bannerImgUrl" style="width:1000px;height:177px">
            </div>
            <div v-else class="f-c-c fd-c" style="height:100%;width:1000px;">
              <i class="el-icon-plus avatar-uploader-icon" />
              <p>上传图片</p>
            </div>
          </el-upload>
          <div>（建议尺寸: 1354 x 240）</div>
        </el-form-item>
        <el-form-item label="设置层级:" prop="level">
          <el-radio v-model="form.level" :disabled="!!id" :label="1">一级</el-radio>
          <el-radio v-model="form.level" :disabled="!!id" :label="2">二级</el-radio>
        </el-form-item>
        <el-form-item label="添加方式:" prop="type">
          <div class="content fd-c" style="align-items:flex-start;">
            <div class="f--c" style="height:40px">
              <el-radio v-model="form.type" :disabled="!!id" :label="1">智能自动添加</el-radio>
              <div style="color:#888;font-size:14px">（通过设置添加条件，符合条件的商品将自动被添加到合集中）</div>
            </div>
            <div class="f--c" style="height:40px">
              <el-radio v-model="form.type" :disabled="!!id" :label="2">手动选择添加</el-radio>
              <div style="color:#888;font-size:14px">（通过从商品列表中选择的方式，手动将商品添加到合集中）</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="form.level === 2" label="专辑模板:" prop="style">
          <div class="f--c">
            <div class="template" v-for="item in 2" :key="item" @click="!id && $set(form, 'style', item)">
              <img :src="require(`@/assets/img/group_template_${item}.png`)" :class="{sel: item === form.style, disabled: !!id}" alt="">
              <i v-if="item === form.style" class="iconfont icon-checkbox-circle-fill" :class="{disabled: (item === form.style && !!id)}"></i>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="发货国家设置" prop="country">
          <el-select v-model="form.country" style="width:160px">
            <el-option v-for="item in countryList" :key="item.country" :value="item.country" :label="item.countryCn" />
          </el-select>
        </el-form-item> -->
      </el-form>
      
      <div class="foot-btn f-c-c">
        <el-button size="medium" type="primary" @click="saveFirstStep">保存，下一步</el-button>
      </div>
    </div>
    <div v-if="process === 2" class="box bg-white">
      <!-- <div v-if="condition" class="automatic-content" style="margin-bottom:100px">
        <h4 style="font-size:15px;margin-bottom:10px">智能自动添加</h4>
        <div v-if="form.rule.level === 1" class="item f--c">
          <div class="title">发货国家设置:</div>
          <el-select v-model="form.rule.country" @change="getWarehouseList(form.rule)" clearable style="width:160px">
            <el-option v-for="item in countryList" :key="item.country" :value="item.country" :label="item.countryCn" />
          </el-select>
          <div class="title">发货仓库:</div>
          <el-select v-model="form.rule.warehouseCode" :disabled="!form.rule.country" clearable style="width:160px">
            <el-option v-for="item in form.rule.warehouseList" :key="item.warehouseCode" :value="item.warehouseCode" :label="item.warehouseName" />
          </el-select>
        </div>
        <div class="item f--c">
          <div class="title">筛选条件:</div>
          <div>全部满足以下条件的产品才能进入专辑</div>
        </div>
        <div class="item f--c">
          <div class="title"></div>
          <div class="ruleList">
            <div v-for="(item, index) in condition.rules" :key="`rule${item.uuid||index}`">
              <condition-item :conditionList="conditionList" :groupItem="item" :showDelete="condition.rules.length>1" :categoryOptions="categoryOptions" :condition="condition" @deleteCondition="deleteRule('condition', index)" />
            </div>
            <el-button type="text" @click="addrule('condition')"><i class="iconfont icon-add-line"></i>新增条件</el-button>
          </div>
        </div>
        <div v-if="condition.groups && condition.groups.length" class="item f--c" style="align-items:flex-start;">
          <div class="title">设置二级:</div>
          <div>
            <div class="packet" v-for="(item, index) in condition.groups" :key="`groups${index}`">
              <div class="item f--c">
                <div class="title" style="width:120px">分组名称:</div>
                <div class="f-b-c" style="width:100%;padding-right:30px">
                  <el-input v-model="item.groupName" size="medium"  placeholder="请输入" style="width:300px;"></el-input>
                  <el-popconfirm
                    v-if="condition.groups.length>1"
                    title="确定要删除此组吗？"
                    @confirm="deleteRule('group', index)"
                  >
                    <el-button slot="reference" type="text" style="color:#888">删除本组</el-button>
                  </el-popconfirm>
                </div>
              </div>
              <div class="item f--c">
              <div class="title" style="width:120px">发货国家设置:</div>
                <el-select v-model="item.country" @change="getWarehouseList(item)" clearable style="width:160px">
                  <el-option v-for="item in countryList" :key="item.country" :value="item.country" :label="item.countryCn" />
                </el-select>
                <div class="title" style="width:120px">发货仓库:</div>
                <el-select v-model="item.warehouseCode"  :disabled="!item.country" clearable style="width:160px">
                  <el-option v-for="item in item.warehouseList" :key="item.warehouseCode" :value="item.warehouseCode" :label="item.warehouseName" />
                </el-select>
              </div>
              <div class="item f--c" style="align-items:flex-start;">
                <div class="title" style="width:120px">特殊筛选条件:</div>
                <div class="ruleList">
                  <div v-for="(t, i) in item.rules" :key="`groups_rule${t.uuid||i}`">
                    <condition-item :conditionList="conditionList" :groupItem="t" :showDelete="item.rules.length>1" :categoryOptions="categoryOptions" :condition="condition" @deleteCondition="deleteRule('condition', index, i)" />
                  </div>
                  <el-button type="text" @click="addrule('condition', index)"><i class="iconfont icon-add-line"></i>新增条件</el-button>
                </div>
              </div>
            </div>
            <div>
              <el-button type="text" @click="addrule('group')"><i class="iconfont icon-add-line"></i>新增分组</el-button>
            </div>
          </div>
        </div>
        <div class="foot-btn f-c-c">
          <el-popconfirm
            v-if="!id"
            title="确定要清除已选设置么？"
            @confirm="getAlbumModuleDetail(1)"
          >
            <el-button slot="reference" size="medium">清空已选，上一步</el-button>
          </el-popconfirm>
          <el-button size="medium" type="primary" @click="submit" style="margin-left:20px">下一步</el-button>
        </div>
      </div> -->

      <intelligent-set
        v-if="condition"
        ref="intelligentSet"
        :form="form"
        :condition="condition"
        :countryList="countryList"
        :conditionList="conditionList"
        :categoryOptions="categoryOptions"
        @addrule="addrule"
        @deleteRule="deleteRule"
        @getWarehouseList="getWarehouseList"
        @submit="submit"
        @resetData="resetData"
        ></intelligent-set>

      <!-- <div v-if="manual" class="manual-content">
        <h4 style="font-size:15px;margin-bottom:10px">手动选择添加</h4>
        <div v-if="this.form.level === 2" class="item f--c" style="align-items:flex-start;">
          <div class="title">设置二级:</div>
          <div>
            <div v-for="(item, i) in manual" :key="`manual${i}`" class="packet f-b-c">
              <div class="left f--c">
                <div>分组名称：</div>
                <span v-if="+albumType === 1" style="width:400px">{{item.groupName}}</span>
                <el-input v-else v-model.trim="item.groupName" style="width: 400px" placeholder="请输入分组名称" @blur="setAlbumModuleProduct(item)"></el-input>
                <el-button size="medium" type="primary" @click="showManual(item)" style="margin-left:10px">查看商品</el-button>
              </div>
              <div class="right">
                <el-popconfirm
                  v-if="manual.length>1 && +albumType!==1"
                  title="确定要删除此组吗？"
                  @confirm="deleteManual(item, i)"
                >
                  <el-button slot="reference" type="text" style="color:#888">删除本组</el-button>
                </el-popconfirm>
              </div>
            </div>
            <div  v-if="+albumType !== 1">
              <el-button type="text" @click="addManual('group')"><i class="iconfont icon-add-line"></i>新增分组</el-button>
            </div>
          </div>
        </div>
        <div v-if="this.form.level === 2" class="foot-btn f-c-c">
          <el-popconfirm
            v-if="!id"
            title="确定要清除已选设置么？"
            @confirm="deleteManual('all')"
          >
            <el-button slot="reference" size="medium">清空已选，上一步</el-button>
          </el-popconfirm>
          <el-button v-else size="medium" @click="$router.back()">返回专辑列表</el-button>
          <el-button type="primary" size="medium" @click="initThirdlyStep">下一步</el-button>
        </div>
        <manual-goods-list ref="manualGoodsList1" v-else :manualForm="manualForm" :countryList="countryList" :form="form" @backFirstStep="getAlbumModuleDetail(1)" />
      </div> -->
    </div>
    <div v-if="process === 2" class="box bg-white">
      <el-tabs v-if="form.level === 2" v-model="activeTabs" @tab-click="changeTabs">
        <el-tab-pane v-for="(item, i) in (this.form.type === 1 ? this.condition.groups : this.manual)" :key="item.groupName" :label="item.groupName" :name="i+''" />
      </el-tabs>
      <add-group v-if="albumType != 1" ref="addGroup" :manualForm="manualForm" :manual="manual" @setGroupSuccess="setGroupSuccess"></add-group>
      <div>
        <manual-goods-list
        ref="manualGoodsList3"
        :form="form"
        :manual="manual"
        :manualForm="manualForm"
        :process="process"
        :albumType="albumType"
        :countryList="countryList"
        @updateManual="updateManual"
        @handleTabsAdd="handleTabsAdd"
        @backFirstStep="getAlbumModuleDetail(1)"
        @deleteManual="deleteManual"
        @editManual="editManual"
        @showIntelligentSet="showIntelligentSet"
        />
      </div>
      <div class="f-c-c">
        <el-button size="medium" @click="process=1">上一步</el-button>
        <el-button type="primary" size="medium" @click="$router.back()">返回专辑列表</el-button>
      </div>
    </div>

    <!-- 商品二级弹窗 -->
    <el-dialog title="二级分组" :visible.sync="manualVisible" width="700px" class="manualDialog">
      <div style="margin-bottom:16px;font-size:16px">分组名称：{{ manualForm.groupName }}</div>
      <manual-goods-list ref="manualGoodsList2" :manualForm="manualForm" :albumType="albumType" :countryList="countryList" @updateManual="updateManual" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="$router.back()">返回专辑列表</el-button>
        <el-button @click="manualVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 商品排序插入规则 -->
    <el-dialog title="新增的商品排序设置" :visible.sync="sortVisible" width="700px" class="manualDialog">
      <div>专辑商品处于手动排序时，新增商品将出现在</div>
      <el-radio-group v-model="insertSort" class="insertSort">
        <el-radio :label="1">当前所有商品后方</el-radio>
        <el-radio :label="2">当前所有商品前方（置顶商品后方）</el-radio>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sortVisible = false">取消</el-button>
        <el-button type="primary" @click="insertSortAffirm">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import API from '@/api';
import { guid } from '@/utils/index';
import conditionItem from './conditionItem.vue';
import ManualGoodsList from './manualGoodsList.vue';
import { copy } from '@/utils'
import RichEditor from '@/views/operation/copywriting/components/RichEditor.vue'
import AddGroup from './addGroup.vue';
import IntelligentSet from './IntelligentSet.vue';

const rules = {
  name: [
    { required: true, message: '请输入专辑名称', trigger: 'blur' },
  ],
  seoTitle: [
    { required: true, message: '请输入SEO标题', trigger: 'blur' },
  ],
  seoDescription: [
    { required: true, message: '请输入SEO描述', trigger: 'blur' },
  ],
  moduleUrl: [
    { required: true, message: '请输入网址', trigger: 'blur' },
  ],
  sort: [
    { required: true, message: '请输入优先级', trigger: 'blur' }
  ],
  bannerImgUrl: [
    { required: true, message: '请选择banner图', trigger: 'change' }
  ],
  level: [
    { required: true, message: '请选择层级', trigger: 'change' }
  ],
  type: [
    { required: true, message: '请选择添加方式', trigger: 'change' }
  ],
  style: [
    { required: true, message: '请选择专辑模板', trigger: 'change' }
  ],
}

export default {
  components: { RichEditor,conditionItem, ManualGoodsList, AddGroup, IntelligentSet },
  data() {
    return {
      id: '',
      albumType: undefined, // 专辑类型
      linkUrl: '',
      bg1: `url(${require('@/assets/img/process1.png')}) no-repeat`,
      bg2: `url(${require('@/assets/img/process2.png')}) no-repeat`,

      kakaUrl: process.env.VUE_APP_KAKACLO_URL+'/album/',

      process: 1, // 步骤
      form: {
        rule:{} // 商品规则合集
      },
      condition: undefined , // 自动添加对象
      manual: undefined, // 手动添加对象
      rules,
      categoryOptions: [], // 品类数组
      conditionList: [], // 条件列表
      bluring: false, // blur与click事件冲突
      manualForm: {},
      manualVisible: false,
      countryList: [],

      activeTabs: '0',
      sortVisible: false, // 商品排序插入规则弹窗
      insertSort: 1,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.$set(this.form, 'style', 1)
    this.albumType = this.$route.query.albumType
    this.getCategoryList()
    this.getAlbumModuleCondition()
    this.getAlbumModuleDetail()
    this.getWarehouseCountry()
  },
  methods:{
    open() {
      window.open(this.linkUrl)
    },
    // 添加筛选条件
    addrule(type, i) {
      let obj = {
        conditionCode: undefined,
        operationCode: undefined,
        value: [],
        widgetType: 1,
        uuid: guid()
      }
      if (type === 'condition') {
        if (i||i===0) {
          this.condition.groups[i].rules.push(obj)
        } else {
          this.condition.rules.push(obj)
        }
      } else {
        this.condition.groups.push({
          groupName: undefined,
          rules: [obj],
          uuid: guid()
        })
      }
    },
    // 删除筛选条件
    deleteRule(type, index, i) {
      if (type === 'condition') {
        if (i||i===0) {
          this.condition.groups[index].rules.splice(i, 1)
        } else {
          this.condition.rules.splice(index, 1)
        }
      } else {
        this.condition.groups.splice(index, 1)
      }
    },
    saveFirstStep() {
      this.$refs.form.validate((valid) => {
        if (!valid) return this.$message.warning('请填选完必填项')
        this.form.rule.level = this.form.level
        this.form.rule.type = this.form.type
        if (this.form.level === 1) this.form.style = 1
        
        let form = _.cloneDeep(this.form)
        this.form.id ? this.setAlbumModule(form, 1) : this.addAlbumModule(form)
      })
    },

    // 显示自动添加弹窗
    showManual(row) {
      if (!row.groupName) {
        this.$message.warning('请添加组名')
        return
      }
      if (this.bluring) {
        setTimeout(() => {
          this.showManual(row)
        }, 500)
        return
      }
      this.manualVisible = true
      this.manualForm = {
        moduleId: this.form.moduleId || undefined,
        moduleRuleId: this.form.moduleRuleId || undefined,
        groupId: row.groupId || undefined,
        groupName: row.groupName || undefined,
        country: row.country || undefined,
        type: this.form.type,
        defaultSort: row.defaultSort || 4,
      }
      this.$nextTick(() => {
        this.$refs.manualGoodsList2.show()
      })
    },
    // 自动添加删除组
    deleteManual(row, i) {
      API.deleteAlbumModuleGroup({
        moduleId: this.manualForm.moduleId,
        groupId: row === 'all' ? undefined : row.groupId
      }).then(res => {
        if (res.code !== 10000) return this.$message.warning(res.message)
        if (row === 'all') this.getAlbumModuleDetail(1)
        else {
          this.manual.splice(i, 1)
          if (row.changeTabs) {
            this.activeTabs = '0'
            this.changeTabs()
          }
        }
      })
    },
    // 自动添加新增组
    addManual() {
      this.manual.push({
        groupName: '',
        groupId: undefined
      })
    },

    // 新增专辑
    addAlbumModule(form) {
      if (form.level === 1 && form.type === 1) form.rule.defaultSort = 4
      API.addAlbumModule(form).then(({ code, data, message }) => {
        if (code !== 10000) {
          this.$message.error(message)
          this.initFirstStep(this.form)
          return
        }
        this.initSecondStep(data)
      })
    },
    // 编辑专辑
    setAlbumModule(form, step) {
      API.setAlbumModule(form).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (step === 1) this.initSecondStep(this.form) 
        else {
          this.initThirdlyStep()
          // this.$message.success('设置成功')
          // this.$router.back()
        }
      })
    },
    // 查看专辑详情
    getAlbumModuleDetail(step) {
      let id = this.form.id ? this.form.id : this.$route.query.id ? this.$route.query.id : ''
      if (!id) return
      API.getAlbumModuleDetail(id).then(res => {
        this.linkUrl = `${process.env.VUE_APP_KAKACLO_URL}/mall/album?moduleId=${res.data.moduleId}`
        if (step === 1) {
          this.initFirstStep(res.data)
        } else {
          this.initSecondStep(res.data, this.id ? 1 : 2)
        }
      })
    },

    // 设置商品
    setAlbumModuleProduct(row) {
      if (!row.groupName) {
        this.$message.warning('请输入组名')
        return
      }
      let param = {
        moduleId: this.manualForm.moduleId,
        moduleRuleId: this.manualForm.moduleRuleId,
        groupId: row.groupId,
        groupName: row.groupName,
        country: row.country,
        defaultSort: row.defaultSort || 4,
      }
      this.bluring = true
      API.setAlbumModuleProduct(param).then(res => {
        if (res.code === 10000) {
          this.$set(row, 'groupId', res.data.groupId)
          this.bluring = false
        }
      })
    },

    // 初始化第一步
    initFirstStep(data) {
      data = _.cloneDeep(data)
      this.$set(this.$data, 'form', { ...data, rule: { type: data.rule.type, level: data.rule.level }, level: data.rule.level, type: data.rule.type })
      this.$set(this.$data, 'condition', undefined)
      this.$set(this.$data, 'manual', undefined)
      this.manualForm = {
        moduleId: this.form.moduleId || undefined,
        moduleRuleId: this.form.moduleRuleId || undefined,
        groupId: undefined,
        groupName: undefined,
        level: this.form.level,
        type: this.form.type,
        country: undefined,
        defaultSort: 4
      }
      this.$set(this.$data, 'process', 1)
    },
    // 初始化第二步
    initSecondStep(data, step) {
      this.$set(this.$data, 'form', { ..._.cloneDeep(data), level: data.rule.level, type: data.rule.type })
      this.$set(this.$data, 'condition', +this.form.type===1?{}:undefined)
      this.$set(this.$data, 'manual', +this.form.type===2?[]:undefined)
      if (this.form.type === 1) {
        if (this.form.rule.condition) this.$set(this.$data, 'condition', this.form.rule.condition)
        else this.$set(this.condition, 'rules', [{
          conditionCode: undefined,
          operationCode: undefined,
          value: [],
          widgetType: 1,
          uuid: guid()
        }])
        let manualForm = {
          moduleId: this.form.moduleId || undefined,
          moduleRuleId: this.form.moduleRuleId || undefined,
          level: this.form.level,
          type: this.form.type,
          defaultSort: this.form.rule.defaultSort || undefined
        }
        if (this.form.level === 2 && !this.form.rule.condition) {
          this.$set(this.condition, 'groups', [{ groupName: undefined, rules: [
            {
              conditionCode: undefined,
              operationCode: undefined,
              value: [],
              widgetType: 1,
              uuid: guid()
            }
          ] }])
        } else if (this.form.level === 2 && this.form.rule.condition && this.form.rule.condition.groups) {
          manualForm.groupId = this.form.rule.condition.groups.length ? this.form.rule.condition.groups[0].groupId : undefined
          manualForm.groupName = this.form.rule.condition.groups.length ? this.form.rule.condition.groups[0].groupName : undefined
          manualForm.country = this.form.rule.condition.groups.length ? this.form.rule.condition.groups[0].country : undefined
          manualForm.defaultSort = this.form.rule.condition.groups.length ? this.form.rule.condition.groups[0].defaultSort : undefined
        }
        this.manualForm = manualForm
      }
      if (this.form.type === 2) {
        this.manualForm = {
          moduleId: this.form.moduleId || undefined,
          moduleRuleId: this.form.moduleRuleId || undefined,
          groupId: this.form.rule.group&&this.form.rule.group.length ? this.form.rule.group[0].groupId : undefined,
          groupName: this.form.rule.group&&this.form.rule.group.length ? this.form.rule.group[0].groupName : undefined,
          level: this.form.level,
          type: this.form.type,
          country: this.form.rule.group&&this.form.rule.group.length ? this.form.rule.group[0].country : undefined,
          defaultSort: this.form.rule.group&&this.form.rule.group.length ? this.form.rule.group[0].defaultSort : 4,
        }
        if (this.form.rule.group) this.$set(this.$data, 'manual', this.form.rule.group)
        if (this.form.level === 2 && !this.form.rule.group) {
          this.manual.push({
            groupName: '',
            groupId: undefined
          })
        }
      }
      this.activeTabs = '0'
      this.$set(this.$data, 'process', step||2)
      // if (this.process === 2) {
      //   this.$nextTick(() => {
      //     this.showIntelligentSet()
      //   })
      // }
    },

    // 第三步
    initThirdlyStep() {
      // this.$set(this.$data, 'process', 3)
      this.changeTabs('init')
    },

    // 切换分组
    changeTabs(isInit) {
      let i = this.activeTabs
      this.manualForm = {
        moduleId: this.form.moduleId || undefined,
        moduleRuleId: this.form.moduleRuleId || undefined,
        groupId: this.form.type === 1 ? ((this.condition.groups && this.condition.groups[i].groupId) || undefined) : (this.manual[i].groupId || undefined), // row.groupId || undefined,
        groupName: this.form.type === 1 ? ((this.condition.groups && this.condition.groups[i].groupName) || undefined) : (this.manual[i].groupName || undefined), // row.groupName || undefined,
        defaultSort: this.form.type === 1 ? (this.form.level === 1 ? this.form.rule.defaultSort : (this.condition.groups && this.condition.groups[i].defaultSort || 4)) : (this.manual[i].defaultSort || 4), // row.groupName || undefined,
        type: this.form.type,
        country: this.form.type === 2 ? this.manual[i].country : undefined
      }
      // if (isInit !== 'init') {
        this.$nextTick(() => {
          this.$refs.manualGoodsList3.show()
        })
      // }
    },

    // 提交
    submit() {
      let obj = _.cloneDeep(this.form)
      if (this.condition) {
        obj.rule.condition = this.condition
        let is_valid = true
        this.condition.rules.forEach(item => {
          if (!item.conditionCode || !item.operationCode || !item.value.length) {
            is_valid = false
          }
          item.value.length && item.value.forEach(val => {
            if (!val && val!== 0) {
              is_valid = false
            }
          })
        })
        this.condition.groups && this.condition.groups.forEach(item => {
          if (!item.groupName) {
            is_valid = false
          }
          item.rules.forEach(t => {
            if (!t.conditionCode || !t.operationCode || !t.value.length) {
              is_valid = false
            }
            t.value.length && t.value.forEach(val => {
              if (!val && val!== 0) {
                is_valid = false
              }
            })
          })
        })
        if (!is_valid) return this.$message.warning('请填写完整信息')
        if (this.condition.groups && this.condition.groups.length) {
          let unionList = _.unionBy(this.condition.groups, 'groupName')
          if (unionList.length !== this.condition.groups.length) return this.$message.warning('分组名称不能重复')
        }
        this.$refs.intelligentSet.close('success')
      }
      this.setAlbumModule(obj, 2)
    },

    // 智能添加重置数据
    resetData(rawCondition, rawFormRule) {
      this.condition = rawCondition
      if (this.form.rule.level === 1) {
        this.$set(this.form, 'rule', rawFormRule)
      }
    },

    // 获取条件
    getAlbumModuleCondition() {
      API.getAlbumModuleCondition().then(res => {
        this.conditionList = res.data.map(item => ({
          ...item,
          conditionCode: JSON.parse(item.conditionCode),
          operationJson: JSON.parse(item.operationJson),
          widgetType: JSON.parse(item.widgetType)
        }))
      })
    },
    // 获取品类列表
    getCategoryList() {
      API.getCategoryList({ pageNumber: 1, pageSize: 1000 }).then(({ data }) => {
        if (data && data.list.length) {
          this.deletechildList(data.list)
          this.categoryOptions = data.list
        }
      })
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },

    // 上传
    beforeUpload(file, type) {
      API.signValue({ directory: 'album/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'album/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.$set(this.form, type, result.data)
        })
      })
      return false
    },

    // 获取仓库下所有国家列表
    getWarehouseCountry() {
      API.getWarehouseCountry().then(res => {
        this.countryList = res.data
      })
    },

    //发货国家change事件
    getWarehouseList(row) {
      this.$set(row, 'warehouseCode', undefined)
      this.countryList.forEach(item => {
        if (item.country === row.country) row.warehouseList = item.warehouseList
      })
    },
    // 新增分组后，选择发货国家后 更新manual
    updateManual(manualForm) {
      if (this.form.type === 1) {
        if (this.form.level === 1) this.form.rule.defaultSort = manualForm.defaultSort
        else this.condition.groups && this.condition.groups.forEach(item => {
          if (item.groupId && item.groupId === manualForm.groupId) {
            this.$set(item, 'defaultSort', manualForm.defaultSort)
          }
          if (!item.groupId && item.groupName === manualForm.groupName) {
            this.$set(item, 'defaultSort', manualForm.defaultSort)
          }
        })
      }
      if (this.form.type === 2) {
        this.manual && this.manual.forEach(item => {
          if (item.groupId === manualForm.groupId) {
            manualForm.country && this.$set(item, 'country', manualForm.country)
            manualForm.defaultSort && this.$set(item, 'defaultSort', manualForm.defaultSort)
          }
        })
        this.manualForm.defaultSort = manualForm.defaultSort 
      }
    },

    insertSortAffirm() {
    },
    handleCopy() {
      copy(this.kakaUrl+this.form.moduleUrl)
    },
    // 富文本主体内容
    inputRichEditorValue(value) {
      this.form.description = value
    },
    handleInput() {
      let value = this.form.moduleUrl
      value = value.replace(' ','-')
      value = value.replace(/[^\w\/-]/ig,'')
      this.$set(this.form, 'moduleUrl', value)
    },

    // 创建分支
    handleTabsAdd() {
      this.$refs.addGroup.show({ type: 'add' })
    },
    // 最新的设置
    editManual() {
      this.$refs.addGroup.show({ type: 'edit' })
    },
    // 设置分组成功
    setGroupSuccess(type, data) {
      if (type === 'add') {
        this.manual.push({
          groupName: data.groupName,
          groupId: data.groupId,
        })
        this.activeTabs = (this.manual.length - 1) + ''
        if (this.form.type === 2 && !this.$route.query.id && this.form.rule.group.findIndex(t => t.groupId === data.groupId) < 0) {
          this.form.rule.group.push({
            groupName: data.groupName,
            groupId: data.groupId,
          })
        }
        this.changeTabs()
      } else {
        if (this.form.type === 2 && !this.$route.query.id) {
          if (!this.form.rule.group) {
            this.form.rule.group = [{
              groupName: data.groupName,
              groupId: data.groupId,
            }]
          } else if (this.form.rule.group.findIndex(t => t.groupId === data.groupId) < 0) {
            this.form.rule.group.push({
              groupName: data.groupName,
              groupId: data.groupId,
            })
          }
        }
        if (this.manual.findIndex(t => t.groupId === data.groupId) === -1) {
          this.manual[0].groupId = data.groupId
          this.manual[0].groupName = data.groupName
        } else {
          this.manual.find(t => t.groupId === data.groupId).groupName = data.groupName
        }
        this.manualForm.groupId = data.groupId
        this.manualForm.groupName = data.groupName
      }
    },
    showIntelligentSet() {
      this.$refs.intelligentSet.show()
    },
  }
}
</script>

<style lang="scss" scoped>
.tips-content {
  position: relative;
  top: 20px;
  color: #606266;
  font-size: 14px;
  .explain{
    position: relative;
    left: -42px;
  }
  p {
    line-height: 24px;
  }
}
.album-config {
  min-width: 1300px;
  position: relative;
  .icon-tips {
    position: absolute;
    left: 80px;
    top: 28px;
    >i{
      font-size: 40px;
    }
  }

  .step-bar{
    padding-top: 20px;
    >div{
      width: 300px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-size:100% 100% !important;
    }
    >div:first-child{
      background: url('../../../../assets/img/process2.png') no-repeat;
      background-size:100% 100% !important;
    }
  }

  .template {
    position: relative;
    width: 130px;
    height: 124px;
    margin-right: 20px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    i {
      position: absolute;
      top: 6px;
      right: 10px;
      font-size: 24px;
      color: #add049;
      border: unset !important;
    }
    .sel {
      border: 1px solid #add049;
    }
    .disabled {
      border: 1px solid #ddd;
      color: #aaa;
      cursor: no-drop;
    }
  }

  .foot-btn {
    margin-top: 20px;
  }

  .box {
    margin-bottom: 10px;
    padding: 20px 10px;

    h3 {
      margin-bottom: 20px;
    }

    .upload-img{
      height: 177px;
      font-size: 14px;
      /deep/ .el-upload {
        border: 1px dotted #999 !important;
        height: 100%;
      }
      .avatar-uploader-icon {
        font-size: 24px;
        font-weight: 600;
      }
      img {
        height: 16  0px;
        object-fit: cover;
      }
    }

    .item {
      display: flex;
      margin-bottom: 22px;

      .title {
        height: 40px;
        width: 150px;
        text-align: right;
        padding-right: 12px;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        flex-shrink: 0;
      }
      .content {
        display: flex;
        align-items: center;
      }
    }

    .automatic-content {
      padding-left: 150px;
      .item {
        margin-bottom: 10px;
        font-size: 14px;
        color: #606266;

        .ruleList{
          >div{
            margin-bottom: 10px;
          }
        }

        .packet {
          border: 1px solid #ccc;
          width: 940px;
          padding: 10px 0;
          margin-bottom: 10px;
        }
        .packet:last-child {
          margin: 0;
        }
      }
    }

    .manual-content {
      padding: 0 20px;
      // padding-left: 150px;
      .packet{
        border: 1px solid #ccc;
        width: 940px;
        padding: 10px 20px;
        margin-bottom: 10px;
      }
    }
  }

  .manualDialog {
    /deep/ .el-dialog__body{
      padding: 10px 20px;
    }
  }

  .insertSort {
    padding: 20px;
    display: flex;
    flex-direction: column;
    /deep/ .el-radio {
      margin-bottom: 20px;
    }
  }
}

.site-url {
  /deep/ input {
    padding-left: 2px;
  }
  .el-icon-document-copy {
    margin: 0 10px;
  }
}
</style>